import React from 'react';
import {
  Box,
  Typography,
  Modal,
  IconButton,
  Button,
  TextField,
  Tooltip
} from '@mui/material';
import { Formik, Form } from 'formik';
import { ReactComponent as CloseIcon } from '../../assets/SVG/close-circle-greay.svg';
import { useTranslation } from 'react-i18next';
import { EditHistoryValues } from './EmbryoGradingAi.helper';


interface RenameGradingHistoryModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (values: EditHistoryValues) => void;
  initialValues?: EditHistoryValues;
}



const subLabelSx = {
  '& .MuiInputLabel-root': {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px',
    color: '#9E9E9E',
    bgcolor: '#FFFFFF',
    px: 1,
    py: 0.5,
    borderRadius: 2
  },
                      
};


const boxContainerSx={
  width: 480,
  bgcolor: 'background.paper',
  borderRadius: 4,
  mx: 'auto',
  mt: '20%',
  boxShadow: 24,
  outline: 'none',
  overflow: 'hidden',
};

const headerSx = {
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '18px',
  color: '#232323',
};


const closeIconSx = {
  color: '#9E9E9E',
  '&:hover': {
    backgroundColor: 'rgba(158, 158, 158, 0.1)',
  },
};

const closeSx ={
  flex: 1,
  borderRadius: 3,
  textTransform: 'none',
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '14px',
  color: '#666666',
  borderColor: '#E0E0E0',
  '&:hover': {
    borderColor: '#CCCCCC',
    backgroundColor: '#F5F5F5',
  },
  padding: 1.5,
};


const saveSx ={
  flex: 1,
  borderRadius: 3,
  textTransform: 'none',
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '14px',
  backgroundColor: '#666666',
  '&:hover': {
    backgroundColor: '#555555',
  },
  padding: 1.5,
};






const RenameGradingHistoryModal: React.FC<RenameGradingHistoryModalProps> = ({
  open,
  onClose,
  onSave,
  initialValues = {
    name: ''
  }
}) => {

  const { t: tAiGrading } = useTranslation('aiGrading_config');



  return (
    <Modal open={open} onClose={onClose}> 
      <Box
        sx={boxContainerSx}
      >
        {/* Header */}
        <Box 
          display="flex" 
          justifyContent="space-between" 
          alignItems="center"
          p={1}      
          px={2}
          mb={2}
          borderBottom={'1px solid rgba(226, 227, 229, 1)'}
        >
          <Typography 
            sx={headerSx}
          >
            {tAiGrading('rename')}
          </Typography>
          <Tooltip title={tAiGrading('close')} arrow>
            <IconButton 
              onClick={onClose}
              sx={closeIconSx}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
         
        </Box>

        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            onSave(values);
            onClose();
          }}
        >
          {({ values, handleChange }) => (
            <Form>
              <Box p={3} pt={1}>

                {/* Rename Fields */}
                <Box display="flex" gap={2} mb={2}>
                  <Box flex={2}>
                    <TextField
                      name="name"
                      label={tAiGrading('name')}
                      value={values.name}
                      onChange={handleChange}
                      sx={subLabelSx}
                      fullWidth
                    />
                  </Box>
                </Box>
              </Box>

              {/* Action Buttons */}
              <Box 
                display="flex" 
                justifyContent="space-between" 
                gap={2}
                p={3} 
                pt={0}
              >
                <Button 
                  variant="outlined" 
                  onClick={onClose}
                  sx={closeSx}
                >
                  { tAiGrading('cancel') }
                </Button>
                <Button 
                  variant="contained" 
                  type="submit"
                  sx={saveSx}
                >
                  { tAiGrading('save') }
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
};

export default RenameGradingHistoryModal;